import { trackEvent } from './monitoring';

export const MAX_BOUNTY_SUCCESS_MESSAGE = 'Lead reported to MaxBounty';
// Callback to Max Bounty affiliate
export const reportToMaxBounty = async (segmentId, sub2) => {
  return fetch(`https://www.chant3rm1.com/lead_nc.asp?o=23900&r=path&d=${segmentId}&i=${sub2}`, {
    mode: 'no-cors',
  }).then(() => {
    trackEvent({ message: MAX_BOUNTY_SUCCESS_MESSAGE });
  });
};
